import { IconClose, IconedButton, Text } from '@bbl-digital/snorre-v2'
import { FileWrapper } from '../types/types'
import FileIcon from '../components/FileIcon'

type FileItemProps = {
  file: FileWrapper
  removeFile: (file: FileWrapper) => void
}

const FilePickerInputItem = ({ file, removeFile }: FileItemProps) => {
  return (
    <div className="flex justify-between items-center border-t mb-1 pt-1 gap-2">
      <div className="flex gap-1 items-center min-w-0 w-full">
        <FileIcon type={file.mimeType} className="shrink-0" />
        <Text className="truncate w-full" title={file.name}>
          {file.name}
        </Text>
      </div>
      <IconedButton
        label="Fjern fil"
        variant="ghost"
        small
        icon={<IconClose />}
        onClick={() => removeFile(file)}
        className="shrink-0"
      />
    </div>
  )
}

export default FilePickerInputItem
